import { IAgent } from "store/entities/agents";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { ITeam } from "store/entities/teams";

export function filterTeam(query = "") {
  const clearQuery = query.trim().toLocaleLowerCase();

  return (team: ITeam): boolean => (team.name || "").toLocaleLowerCase().indexOf(clearQuery) !== -1;
}

export function sortTeams(field: string, desc: boolean) {
  switch (field) {
    case "name":
      return (a: ITeam, b: ITeam): number => (desc ? -1 : 1) * a.name.localeCompare(b.name);

    case "agents":
      return (a: ITeam, b: ITeam): number =>
        (desc ? -1 : 1) * (a.isDefault ? 1 : a.agentIds.length - b.agentIds.length);

    default:
      // FIXME: Fix this the next time the file is edited.
      // @ts-expect-error TS(6133): 'a' is declared but its value is never read.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars
      return (a: ITeam, b: ITeam) => 0;
  }
}

export function getTeamAgents(team: ITeam, agents: IAgent[]): IAgent[] {
  // @ts-expect-error TS2322
  return (
    team.agentIds // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .map((teamAgentId: any) => agents.find(agent => agent.id === teamAgentId))
      // team.agentIds can contain reference to inexisting agents
      // so we need to filter-out falsy values
      .filter(Boolean)
  );
}

export function calculateTeamAgentIds(teamId: string, agents: IAgent[]): string[] {
  return agents.filter((agent: IAgent) => agent.teamIds.includes(teamId)).map(agent => agent.id);
}

export function getTeamById(teams: ITeam[], teamId: string): ITeam {
  // @ts-expect-error TS2322
  return teams.find(team => team.id === teamId);
}

export function teamExists(teams: ITeam[], teamId: string): boolean {
  return teams.some(team => team.id === teamId);
}
